var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "button",
      class: {
        "button--primary": _vm.primary,
        "button--secondary": _vm.secondary,
        "is-disabled": _vm.disabled
      },
      attrs: { href: "javascript:void(0);", "data-test": "button-label" },
      on: { click: _vm.onclick }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }